<script lang="ts">var _a, _b, _c;
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import { t } from '../../../../../js/i18n';
import { findSourceStore } from "../../../utilities";
import { Readable } from "svelte/store";
import { CardsDataSourceRegistration } from "../../../common/CardsDataSourceRegistration";
import { f7, Popup } from 'framework7-svelte';
import { Swiper, SwiperSlide } from 'swiper/svelte';
import { resolveUrl } from '../../../../../js/url';
import iconProfile from './profile.svg';
export let element;
export let sources;
let sourceStore1;
function redirectOnDecision() {
    console.log('redirectio: ', won, lost);
    if (won) {
        if (showWinVideo) {
            videoPopupOpened = true;
            setTimeout(() => {
                videoPopupOpened = false;
                setTimeout(() => {
                    resolveUrl(data.WinPage).func();
                }, 0);
            }, 3000);
            try {
                videoRef.play();
            }
            catch (_a) {
                console.log("failed to play video");
            }
        }
        else {
            setTimeout(() => {
                resolveUrl(data.WinPage).func();
            }, 0);
        }
    }
    else if (lost) {
        setTimeout(() => {
            resolveUrl(data.LosePage).func();
        }, 0);
    }
}
function showResultsClick() {
    redirectOnDecision();
}
$: {
    sourceStore1 = findSourceStore($sources, 'YinzCamDropsServerCurrentDrop');
}
;
$: data = (sourceStore1 && $sourceStore1) ? $sourceStore1 : element.data;
$: secondsLeft = (data === null || data === void 0 ? void 0 : data.SecondsLeft) || 0;
$: minutes = Math.min(999, Math.floor(secondsLeft / 60));
$: seconds = (secondsLeft >= 1000 * 60) ? 59 : secondsLeft % 60;
$: endTime = data === null || data === void 0 ? void 0 : data.EndTime;
$: won = (data === null || data === void 0 ? void 0 : data.Won) || false;
$: lost = (data === null || data === void 0 ? void 0 : data.Lost) || false;
$: dropDecided = won || lost;
$: carouselImages = (data === null || data === void 0 ? void 0 : data.CarouselImages) || [];
// This sets up a reactive variable in a feedback loop that, once triggered, stays true even if the other variables change later.
// As long as the system starts off undecided, this will stay undecided for the lifetime of the page, so that we can auto redirect/
// If the system was always decided from the start then we want to show a button in place of the countdown clock.
$: dropWasUndecided = dropWasUndecided || (data && !dropDecided);
$: console.log('dropDecided: ', dropWasUndecided && dropDecided, carouselImages);
$: if (endTime && ((Date.now() - endTime) < 5 * 60 * 1000) && dropWasUndecided && dropDecided) {
    //alert(`Now: ${Date.now()} - EndTime: ${endTime} - Diff: ${Date.now() - endTime} - 5min: ${5*60*1000}`)
    redirectOnDecision();
}
// This is true if you come back to the page after the drop is decided (it's not decided while you're on the page).
$: showResultsButton = dropDecided && !dropWasUndecided;
$: entryCount = (data === null || data === void 0 ? void 0 : data.EntryCount) || 0;
$: viewResultsImageUrl = (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.viewResultsImageUrl;
$: videoSrc = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.videoUrl) || "/static/kitty.mp4";
$: showWinVideo = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.showWinVideo) || false;
//let videoSrc: string = "/static/kitty.mp4";
let videoRef;
let videoPopupOpened = false;
</script>

<CardBase {element}>
  <div class="header-carousel-card">
    <Swiper
      slidesPerView={1}
      spaceBetween={10}
      observer={true}
      observeSlideChildren={false}
    >
      {#each carouselImages as item}
        <SwiperSlide>
          <div class="simple-card">
            {#if item.ImageUrl}
              <div class="thumbnail">
                <img src={item.ImageUrl} alt={item.AltText || 'thumbnail'} />
              </div>
            {/if}
            <div class="content">
              <div class="title"></div>
              <div class="text"></div>
              <!--
              <div class="title">{item.AltText || ""}</div>
              <div class="text">{@html item.text || ""}</div>
              -->
            </div>
          </div>
        </SwiperSlide>
      {/each}
    </Swiper>
    <div class="countdown">
      <div class="drop-count">
        <img src={iconProfile} alt="Profile Icon" />
        <span class="counter-text">{entryCount || 0}</span>
      </div>
      <div class="timer"><span class="counter-text">{(minutes || 0).toString().padStart(minutes >= 100 ? 3 : 2, "0")}:{(seconds || 0).toString().padStart(2, "0")}</span></div>
    </div>
    <Popup opened={videoPopupOpened} onPopupClosed={() => videoPopupOpened = false}>
      <div class="video-wrapper">
        <video src={videoSrc} bind:this={videoRef} playsinline={true}></video>
      </div>
    </Popup>
  </div>
</CardBase>

<style type="text/scss">*, *::after, *::before {
  box-sizing: border-box;
}

.header-carousel-card {
  width: 100%;
  position: relative;
  background: white;
}

.countdown-wrapper {
  width: 100%;
  height: 100%;
  padding: 20px;
}

.simple-card {
  width: 100%;
  height: 100%;
  color: #fff;
  font-family: var(--f7-font-family);
  text-decoration: none;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.simple-card .thumbnail {
  width: 100%;
  height: 100%;
}

.simple-card .thumbnail img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.simple-card .content {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.simple-card .content .text {
  font-size: 20px;
}

.simple-card .content .title {
  font-size: 32px;
  font-weight: bold;
}

.countdown {
  position: absolute;
  left: 24px;
  right: 24px;
  bottom: 13px;
  display: flex;
  justify-content: space-between;
  z-index: 1;
}

.countdown .drop-count, .countdown .timer {
  letter-spacing: 1px;
  height: 42px;
  background: rgba(0, 0, 0, 0.62);
  border-radius: 50px;
  color: white;
  font-family: "Roboto Mono", monospace !important;
  font-weight: normal;
  font-size: 24px;
  padding: 14px 16px 14px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Druk';
  min-width: 75px;
}

.countdown .drop-count i, .countdown .drop-count img, .countdown .timer i, .countdown .timer img {
  margin: 0 8px 0 0;
}

.countdown .drop-count {
  padding-left: 45px;
  padding-right: 12px;
  position: relative;
  text-align: right;
}

.countdown .drop-count img {
  position: absolute;
  border: 1px solid #FFD700;
  border-radius: 50%;
  padding: 1px 0 0 2px;
  left: 6px;
}

.countdown .drop-count span {
  width: 100%;
}

.countdown .counter-text {
  transform: translateY(-1px);
}

:global(.video-wrapper) {
  display: flex;
  align-items: center;
  justify-content: center;
  background: black;
  height: 100%;
}</style>
